var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"base-print-qrcode",staticClass:"base-print-qrcode"},[_c('div',{staticClass:"left"},[_c('base-qrcode',{staticStyle:{"margin-bottom":"10px"},attrs:{"width":_vm.width,"height":_vm.height,"url":_vm.url}})],1),_c('div',{staticClass:"right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }